import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { expertProfileApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ExpertProfileStatus } from '../types/expert-profile';

interface UpdateStatusVariables {
  id: string;
  status: ExpertProfileStatus;
}

export function useUpdateExpertProfileStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: UpdateStatusVariables) =>
      expertProfileApi.updateExpertProfileStatus(variables.id, variables.status),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.expertProfiles.detail(variables.id),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.expertProfiles.lists() });

      const message =
        variables.status === 'active'
          ? 'Expert profile activated successfully'
          : 'Expert profile deactivated successfully';
      toast.success(message);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update expert profile status');
    },
  });
}
